exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal__content[data-v-7596f524]{max-height:80vh}.modal__button[data-v-7596f524]{display:block;margin-top:var(--spacer-xl);margin-bottom:var(--spacer-xl)}\n", ""]);

// exports
